import { Box, Grid } from '@mui/material'
import React, { useEffect } from 'react'
import { SelectedFiltersValues } from './types/SelectedFilterValues'
import { WarehouseDDL } from '../Almacen'
import { ZoneDDL } from '../Zone'
import { ActiveDDL } from './ActiveDLL'
import { TypePositionsDDL } from '../TypePosition/TypePositionsDDL'
import { useTypePosition } from '../../hooks'

interface ControlsSelectorProps {
  handleChangeDDLOption: any
  filtersRequest: SelectedFiltersValues
  editMode: boolean
  isUploading: Boolean
  setRequireZone: React.Dispatch<React.SetStateAction<boolean>>
}

export const ControlsSelector: React.FC<ControlsSelectorProps> = ({
  handleChangeDDLOption,
  filtersRequest,
  editMode,
  isUploading,
  setRequireZone
}) => {
  const {
    typePositionsState: { typePositions },
    getTypePositions
  } = useTypePosition()

  useEffect(() => {
    if (typePositions?.length === 0) {
      getTypePositions()
    }
  }, [])

  const validateSelectedTypePosition = (typePosition: number): boolean => {
    if (!editMode) {
      if (typePosition === undefined && isUploading) return true

      if (typePosition !== undefined && typePosition <= 0 && isUploading)
        return true
    } else {
      if (typePosition > 0) {
        const filteredTypePositions = typePositions?.filter(
          (x) => x.typePositionId === typePosition
        )

        const fieldValue =
          filteredTypePositions && filteredTypePositions.length > 0
            ? filteredTypePositions[0]?.requireZone
            : false

        setRequireZone(fieldValue)
        return fieldValue
      }
    }

    return false
  }

  const valid = (id: number | undefined) => {
    let retorno: boolean = false
    if (!editMode) {
      if (id === undefined && isUploading) retorno = true

      if (id !== undefined && id <= 0 && isUploading) retorno = true
    }
    return retorno
  }

  return (
    <Box className='mb25' display='flex' alignItems='center'>
      <Grid
        container
        spacing={4}
        direction='row'
        alignItems='center'
        justifyContent='center'
        style={{ justifyContent: 'center' }}
      >
        <Grid item xs={3} style={{ textAlign: 'right' }}>
          <WarehouseDDL
            onChange={handleChangeDDLOption}
            value={filtersRequest.warehouseId || -1}
            type='outlined'
            fullWidth
            key={`input-warehouseId`}
            required={valid(filtersRequest.warehouseId)} // requiere selección solo en creación
          />
        </Grid>
        <Grid item xs={3} style={{ textAlign: 'right' }}>
          <ZoneDDL
            onChange={handleChangeDDLOption}
            value={filtersRequest.zoneId || -1}
            variant='outlined'
            fullWidth
            key={`input-zoneId`}
            warehouseId={filtersRequest.warehouseId}
            required={validateSelectedTypePosition(
              filtersRequest.typepositionId !== undefined
                ? filtersRequest.typepositionId
                : 0
            )}
          />
        </Grid>
        <Grid item xs={3} style={{ textAlign: 'right' }}>
          <TypePositionsDDL
            onChange={handleChangeDDLOption}
            value={filtersRequest.typepositionId || -1}
            type='outlined'
            fullWidth
            key={`input-typepositionId`}
            required={valid(filtersRequest.typepositionId)}
            includeNotEditable={false} // No incluye posiciones no editables
          />
        </Grid>
        <Grid item xs={3} style={{ textAlign: 'right' }}>
          <ActiveDDL
            onChange={handleChangeDDLOption}
            value={filtersRequest.activeId || -1}
            variant='outlined'
            fullWidth
            key={`input-active`}
            required={valid(filtersRequest.activeId)}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
